import {Component, inject} from '@angular/core';
import {BanniereComponent} from './banniere/banniere.component';
import {EpochlitheApiService} from '../../../shared/epochlithe/services/epochlithe-api.service';
import {OpenMapComponent} from './open-map/open-map.component';
import {SsrService} from '../../../core/ssr/services/ssr.service';
import {SliderComponent} from './slider/slider.component';
import {CardsDoggoverseComponent} from './cards-doggoverse/cards-doggoverse.component';

@Component({
  selector: 'app-home-page',
  imports: [
    BanniereComponent,
    OpenMapComponent,
    SliderComponent,
    CardsDoggoverseComponent
  ],
  templateUrl: './home-page.component.html',
  styleUrl: './home-page.component.scss'
})
export class HomePageComponent {
  // private readonly epochlitheApiService: EpochlitheApiService = inject(EpochlitheApiService);
  // private readonly ssrService: SsrService = inject(SsrService);

  constructor() {
    // if (this.ssrService.isClientSide) this.epochlitheApiService.health();
  }


}
